const SkeletonBusiness = ({ index = 0 }) => {
  const delay = index * 120;

  return (
    <div
      className="p-4 rounded-[14px] bg-white border border-[var(--line)] h-full"
    >
      {/* Header — avatar + text lines */}
      <div className="flex gap-2.5 items-center mb-3.5">
        <div
          className="h-11 w-11 rounded-lg skeleton-shimmer flex-shrink-0"
          style={{ animationDelay: `${delay}ms` }}
        />
        <div className="flex-1 min-w-0">
          <div
            className="h-3.5 w-28 skeleton-bone mb-2"
            style={{ animationDelay: `${delay + 80}ms` }}
          />
          <div
            className="h-2.5 w-16 skeleton-bone"
            style={{ animationDelay: `${delay + 160}ms` }}
          />
        </div>
      </div>

      {/* Service rows */}
      <div className="space-y-1.5 mb-3.5">
        <div
          className="flex items-center justify-between py-2 px-2.5 rounded-lg skeleton-shimmer"
          style={{ animationDelay: `${delay + 100}ms` }}
        >
          <div className="h-3 w-24 rounded-sm bg-white/60" />
          <div className="h-3 w-16 rounded-sm bg-white/60" />
        </div>
        <div
          className="flex items-center justify-between py-2 px-2.5 rounded-lg skeleton-shimmer"
          style={{ animationDelay: `${delay + 200}ms` }}
        >
          <div className="h-3 w-32 rounded-sm bg-white/60" />
          <div className="h-3 w-14 rounded-sm bg-white/60" />
        </div>
      </div>

      {/* Footer */}
      <div className="pt-2.5 border-t border-gray-100">
        <div
          className="h-3 w-20 skeleton-bone"
          style={{ animationDelay: `${delay + 300}ms` }}
        />
      </div>
    </div>
  );
};

export default SkeletonBusiness;
